import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, skip, switchMap, take } from 'rxjs';

import { UserService } from '@celum/authentication';
import { isTruthy } from '@celum/core/rxjs';
import { TranslationHelper } from '@celum/ng2base/translation';

export const AVAILABLE_LANGUAGES = ['en', 'de', 'fr', 'ja'];

@Injectable({ providedIn: 'root' })
export class LanguageInitializationService {
  private readonly availableLanguages = AVAILABLE_LANGUAGES;

  private userService = inject(UserService);
  private translate = inject(TranslationHelper);
  private destroyRef = inject(DestroyRef);

  public init(): void {
    // Initialize the translations in the beginning (this loads additional translations, which might be needed to display error messages during application startup)
    const defaultLanguage = this.availableLanguages.includes(this.translate.browserLocale) ? this.translate.browserLocale : 'en';
    this.translate.init(defaultLanguage, AVAILABLE_LANGUAGES, defaultLanguage);
    this.userService.currentUser$
      .pipe(
        isTruthy(),
        take(1),
        map(user => user.locale)
      )
      .subscribe(language => this.translate.setLanguage(language));

    this.translate
      .currentLocaleStream()
      .pipe(
        skip(1),
        switchMap(locale => this.userService.changeLocale(locale)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
